import { Stack } from '@mui/material';
import { ConversationDetails } from 'modules/conversations/components/ConversationDetails';

type CandidateProfileAnalysisConversationProps = {
  conversationId: string | null;
};

export const CandidateProfileAnalysisConversation: React.FC<
  CandidateProfileAnalysisConversationProps
> = ({ conversationId }) => {
  if (!conversationId) {
    return null;
  }

  return (
    <Stack sx={{ height: '100%' }}>
      <ConversationDetails
        conversationId={conversationId}
        shouldHideCandidateDetails
      />
    </Stack>
  );
};
